import { importHighcharts } from '@/lib/highcharts'
import { BlockModule } from '../common'
import {
    countTo,
    doIfInViewOrDefer,
    setupChartCounters,
    trendColorClasses,
    trendIconClasses,
} from './common'
import { getMarketDataMonetaryOpr } from '@/api'
import { defineComponent } from 'vue'
import ChartShareButtons from '@/components/website/ChartShareButtons.vue'
import { format, parseISO, addHours } from 'date-fns'

new BlockModule({
    selector: '.block-market-data-monetary-opr',
    vueComponent: defineComponent({
        components: { ChartShareButtons },
        setup() {},
    }),
    async setupBlock(el, onTeardown, blockContext) {
        const chartData = await getMarketDataMonetaryOpr()

        const latestValue = chartData.data[chartData.data.length - 1]
        const beforeLatestValue = chartData.data[chartData.data.length - 2]
        const valueDelta = (latestValue.y || 0) - (beforeLatestValue.y || 0)

        const timestamp = chartData.lastUpdated
        const date = new Date(timestamp)

        const lastUpdatedValue = date
            .toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
            .replace(',', '')
        let trend: keyof typeof trendColorClasses & keyof typeof trendIconClasses = 'neutral'

        if (valueDelta > 0) {
            trend = 'positive'
        } else if (valueDelta < 0) {
            trend = 'negative'
        }

        // const setupCounters = () => {
        //     const previousValue = el.querySelector('.previous-value')
        //     if (previousValue) {
        //         previousValue.classList.add(trendColorClasses[trend])
        //     }

        //     const previousValueIcon = el.querySelector('.previous-value-icon')
        //     if (previousValueIcon) {
        //         previousValueIcon.classList.add(trendIconClasses[trend])
        //     }

        //     const previousValueLabel = el.querySelector('.previous-value-label')
        //     if (previousValueLabel) {
        //         previousValueLabel.textContent = `(${format(latestValue.x, 'PP')})`
        //     }

        //     const currentValueEl = el.querySelector('.current-value-counter')
        //     if (currentValueEl) {
        //         countTo(latestValue.y || 0, (val) => {
        //             currentValueEl.textContent = Number(val).toFixed(1)
        //         })
        //     }

        //     const previousValueEl = el.querySelector('.previous-value-counter')
        //     if (previousValueEl) {
        //         countTo(Math.abs(valueDelta), (val) => {
        //             previousValueEl.textContent = Number(val).toFixed(1)
        //         })
        //     }

        //     const lastUpdatedEl = el.querySelector('.last-updated')
        //     if (lastUpdatedEl && timestamp) {
        //         lastUpdatedEl.textContent = `Last updated: ${lastUpdatedValue}`
        //     }
        // }

        const setupChart = async () => {
            const chartEl = el.querySelector('.chart-container')
            if (!chartEl) return

            const Highcharts = await importHighcharts()

            const oprOverTime = chartData.data.map((point) => {
                return [parseISO(point.x + 'Z').valueOf(), point.y]
            })

            const chart = Highcharts.chart({
                chart: {
                    type: 'line',
                    renderTo: chartEl as HTMLElement,
                    zooming: {
                        type: 'x',
                    },
                },
                title: {
                    text: '',
                },
                xAxis: {
                    lineColor: '#DBDBDB',
                    dateTimeLabelFormats: {
                        year: '%Y',
                    },
                    type: 'datetime',
                    tickInterval: 365 * 24 * 3600 * 1000,
                    zoomEnabled: true,
                    crosshair: true,
                },

                yAxis: {
                    color: '#DBDBDB',
                    title: {
                        text: '(%)',
                        align: 'high',
                        rotation: 0,
                        reserveSpace: false,
                        textAlign: 'left',
                        y: -20,
                    },
                },
                series: [
                    {
                        name: chartData.yLabel,
                        type: 'line',
                        color: '#010066',
                        data: oprOverTime,
                    },
                ],
                tooltip: {
                    valueDecimals: 2,
                    xDateFormat: '%b %e, %Y',
                    shared: true,
                },
                exporting: {
                    enabled: false,
                    filename: 'monetary-opr',
                },
            })

            const download = el.querySelector<HTMLButtonElement>('.download-btn')
            if (download) {
                download.addEventListener('click', () => {
                    chart.downloadCSV()
                })
            }

            onTeardown(() => {
                chart.destroy()
            })
        }

        doIfInViewOrDefer(() => {
            setupChart()
            setupChartCounters(
                el,
                trend,
                latestValue,
                beforeLatestValue,
                null,
                valueDelta,
                timestamp,
                lastUpdatedValue,
                null,
                null,
                null,
                2,
                false,
            )
        }, blockContext)
    },
})
